'use client';

import { FormGroup, FormInputErrors } from '~/components/primitives';
import { std } from '@funkey/shared/utils';
import type { I18n } from '@funkey/locales';
import React from 'react';
import { useI18n } from '~/features/i18n';
import { getInputComponent } from '~/features/form';
import type { db } from '@funkey/api/src';
import { usePartnerRegistrationCtx } from '../context';

export default function PartnerRegistrationPage() {
    const i18n = useI18n();
    const ctx = usePartnerRegistrationCtx();

    return (
        <div className="grid-cols-2 gap-6 lg:grid">
            {std.Object.entries(fields(i18n)).map(([field, config]) => (
                <FormGroup
                    key={field}
                    label={config.label}
                    required={config.required}
                    className="col-span-1"
                >
                    {getInputComponent({
                        ...config,
                        field,
                        value: ctx.formState.values[field],
                        handleChange: ctx.formState.handleChange,
                        options: config.type === 'select' ? config.options : undefined,
                    })}
                    <FormInputErrors errors={ctx.formState.getErrorMessages(field)} />
                </FormGroup>
            ))}
        </div>
    );
}

const fields = (i18n: I18n) =>
    ({
        firstName: { required: true, type: 'text', label: i18n._('First name') },
        lastName: { required: true, type: 'text', label: i18n._('Last name') },
        email: { required: true, type: 'text', label: i18n._('Email address') },
        password: { required: true, type: 'password', label: i18n._('Password') },
        // country: {
        //     required: true,
        //     disabled: true,
        //     type: 'select',
        //     label: i18n._("I'm located in"),
        //     options: I18N_CONF.COUNTRIES.map(countryCode => ({
        //         value: countryCode,
        //         label: COUNTRY_CODE_TRANSLATIONS[countryCode](i18n),
        //     })),
        // },
        language: {
            required: true,
            type: 'select',
            label: i18n._('My language'),
            options: [
                { value: 'en', label: i18n._('English') },
                { value: 'nl', label: i18n._('Dutch') },
                { value: 'fr', label: i18n._('French') },
            ] satisfies Array<{
                value: typeof db.partners.$inferSelect.language;
                label: React.ReactNode;
            }>,
        },
    }) as const satisfies {
        [key: string]: Omit<
            getInputComponent.ComponentProps<any>,
            'handleChange' | 'value' | 'field'
        > & {
            required: boolean;
            label: string;
            options?: { [key: string]: string }[];
        };
    };
